import React from 'react';
import { useTranslation } from 'react-i18next';
import './ConfirmDialog.css';

interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  details?: string[];
  warning?: string;
  hint?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmVariant?: 'primary' | 'danger' | 'success';
  secondaryLabel?: string;
  secondaryVariant?: 'primary' | 'danger' | 'success' | 'warning';
  onSecondary?: () => void;
  onConfirm: () => void;
  onCancel: () => void;
}

function ConfirmDialog({
  isOpen,
  title,
  message,
  details,
  warning,
  hint,
  confirmLabel,
  cancelLabel,
  confirmVariant = 'primary',
  secondaryLabel,
  secondaryVariant,
  onSecondary,
  onConfirm,
  onCancel
}: ConfirmDialogProps) {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="confirm-dialog-overlay" onClick={onCancel}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-dialog-header">
          <h3>{title}</h3>
        </div>
        <div className="confirm-dialog-body">
          <p className="confirm-message">{message}</p>
          {details && details.length > 0 && (
            <ul className="confirm-details">
              {details.map((detail, idx) => (
                <li key={idx}>{detail}</li>
              ))}
            </ul>
          )}
          {warning && (
            <div className="confirm-warning">
              <strong>{warning}</strong>
            </div>
          )}
          {hint && (
            <p className="confirm-hint">{hint}</p>
          )}
        </div>
        <div className="confirm-dialog-footer">
          <button className="btn btn-secondary" onClick={onCancel}>
            {cancelLabel || t('common.cancel')}
          </button>
          {onSecondary && (
            <button className={`btn btn-${secondaryVariant || 'primary'}`} onClick={onSecondary}>
              {secondaryLabel}
            </button>
          )}
          <button className={`btn btn-${confirmVariant}`} onClick={onConfirm}>
            {confirmLabel || t('common.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
